export default "__VITE_ASSET__BTjjV2pb__"